// University Variants Configuration

import { setUniversity1 } from "@/store/slices/university";
import type { UniversityState } from "@/store/slices/university";
import { Form_1 } from "@/components/organisms/admin/forms";
import { UNIVERSITY_VARIANTS } from "../../sectionTypes";
import { UNIVERSITY_1_CONSTANTS } from "../../fields/university/university_1";
import { updateUniversity } from "@/api/admin/university";
import type { VariantConfig } from "../types";
import { COMMON_CONSTANTS } from "../types";

export const UNIVERSITY_VARIANTS_CONFIG: Record<string, VariantConfig> = {
  [UNIVERSITY_VARIANTS.UNIVERSITY_1]: {
    id: UNIVERSITY_VARIANTS.UNIVERSITY_1,
    name: "University Details",
    description: "University Details",
    componentFields: UNIVERSITY_1_CONSTANTS.UNIVERSITY_FIELDS_CONFIG,
    showTable: false,
    setAction: setUniversity1,
    formComponent: Form_1,
    previewComponent: null,
    selector: (state: UniversityState) => state.university_1,
    updateMethod: updateUniversity,
    transformDataForPreview: (data: any) => ({ data: data || {} }),
    constants: { ...COMMON_CONSTANTS, SUCCESS_MESSAGE: "University details saved successfully" },
  },
};

export const getUniversityVariantDetails = (variantId: string) => 
  UNIVERSITY_VARIANTS_CONFIG[variantId];

